import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  direction?: 'horizon' | 'vertical'
  gap?: 4 | 8
}

const TextAlign = ({ children, direction = 'vertical', gap = 8 }: Props) => {
  const gapValue = gap / 4
  return (
    <>
      <div className={clsx('flex', `gap-${gapValue}`, direction == 'vertical' && 'flex-col')}>
        {children}
      </div>
    </>
  )
}

export default TextAlign
